import { cn } from '@/utils/cn'

export type TabValue =
  | 'products'
  | 'summary'
  | 'financials'
  | 'analytics'
  | 'comments'

interface Tab {
  value: TabValue
  label: string
}

// TODO: Summary tab - show plan overview, financial rollups, and key metrics
// TODO: Analytics tab - show charts/visualizations of plan performance data
// TODO: Comments tab - show discussion thread with @mentions and activity history
const TABS: Tab[] = [
  { value: 'products', label: 'Products' },
  { value: 'summary', label: 'Summary' },
  { value: 'financials', label: 'Financials' },
  { value: 'analytics', label: 'Analytics' },
  { value: 'comments', label: 'Comments' },
]

interface PlanDetailTabsProps {
  activeTab: TabValue
  onTabChange: (tab: TabValue) => void
}

export function PlanDetailTabs({
  activeTab,
  onTabChange,
}: PlanDetailTabsProps) {
  return (
    <div className="inline-flex w-fit rounded-lg border border-[#fee2e4] bg-[#fef2f3] p-1 ">
      {TABS.map(tab => (
        <button
          key={tab.value}
          onClick={() => onTabChange(tab.value)}
          className={cn(
            'px-4 py-2 text-sm font-medium rounded-md transition-colors cursor-pointer',
            'text-[#9B1924]',
            activeTab === tab.value ? 'bg-white shadow-sm' : 'hover:bg-white/50'
          )}
        >
          {tab.label}
        </button>
      ))}
    </div>
  )
}
